<template>
  <div
    class="database"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <Pic-top></Pic-top>
    <div class="databaseTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">Database</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="databaseContent">
      <div class="section">
        <!-- PC端 -->
        <div class="dataType hidden-xs-only">
          <!-- <div
            class="left pointer wow animate__fadeInLeft animate__animated"
            @click="goDataDetail(1)"
          >
            <img src="../../assets/dataType/data_tang.png" alt="" />
            <div class="type eng_type">Thangka</div>
          </div> -->
          <div class="middle wow animate__fadeIn animate__animated">
            <div class="pointer middleBottom" @click="goDataDetail(1)" style="margin-bottom:40px;">
              <img src="../../assets/dataType/data_tang_1.png" alt="" />
              <div class="type eng_type">Thangka</div>
            </div>
            <div class="pointer middleTop" @click="goDataDetail(2)">
              <img src="../../assets/dataType/data_ni.jpg" alt="" />
              <div class="type eng_type">Clay sculpture</div>
            </div>
          </div>
          <div class="middle wow animate__fadeIn animate__animated">
            <div class="pointer middleBottom" @click="goDataDetail(3)" style="margin-bottom:40px;">
              <img src="../../assets/dataType/buhua.png" alt="" />
              <div class="type eng_type">Mural</div>
            </div>
            <div class="pointer rightBottom" @click="goDataDetail(5)">
              <img src="../../assets/dataType/data_cai.png" alt="" />
              <div class="type eng_type">Paintings</div>
            </div>
          </div>
          <div class="right wow animate__fadeIn animate__animated">
            <div class="pointer rightTop" @click="goDataDetail(4)" style="margin-bottom:40px;">
              <img src="../../assets/dataType/data_dui.png" alt="" />
              <div class="type eng_type">Pile embroidery</div>
            </div>
            <div class="pointer middleTop" @click="goDataDetail(6)">
              <img style="height:300px" src="../../assets/dataType/data_other.png" alt="" />
              <div class="type eng_type">Other</div>
            </div>
          </div>
        </div>
        <!-- 手机端 -->
        <div class="mobile_dataType hidden-sm-and-up">
          <div class="typeTop">
            <!-- <div
              class="typeTopLeft wow animate__fadeInLeft animate__animated"
              @click="goDataDetail(1)"
            >
              <img src="../../assets/dataType/data_tang.png" alt="" />
              <div class="type eng_type">Thangka</div>
            </div> -->
            <div
              class="typeTopRight"
            >
              <div class="dui wow animate__fadeInUp animate__animated" @click="goDataDetail(1)">
                <img src="../../assets/dataType/data_tang_1.png" alt="" />
                <div class="type eng_type">Thangka</div>
              </div>
              <div class="bi wow animate__fadeInUp animate__animated" @click="goDataDetail(4)">
                <img src="../../assets/dataType/data_dui.png" alt="" />
                <div class="type eng_type">Pile embroidery</div>
              </div>
            </div>
            <div
              class="typeTopRight"
            >
              <div class="dui wow animate__fadeInUp animate__animated" @click="goDataDetail(3)">
                <img src="../../assets/dataType/buhua.png" alt="" />
                <div class="type eng_type">Mural</div>
              </div>
              <div class="bi wow animate__fadeInUp animate__animated" @click="goDataDetail(2)">
                <img src="../../assets/dataType/data_ni.jpg" alt="" />
                <div class="type eng_type">Clay sculpture</div>
              </div>
            </div>
          </div>
          <div class="typeBottom">
            <div
              class="ni wow animate__fadeInUp animate__animated"
              @click="goDataDetail(5)"
            >
              <img src="../../assets/dataType/data_cai.png" alt="" />
              <div class="type eng_type">Paintings</div>
            </div>
            <div
              class="cai wow animate__fadeInUp animate__animated"
              @click="goDataDetail(6)"
            >
              <img src="../../assets/dataType/data_other.png" alt="" />
              <div class="type eng_type">Other</div>
            </div>
          </div>
        </div>
        <div class="explain wow animate__fadeInUp animate__animated">
          <div class="explainTop">
            <h2>Terms of Use of Regong Art Database</h2>
            <h3>
              I. Copyright Statement of Original Data of Regong Art Database:
            </h3>
            <p>
              The original data of this website database are collected from
              various Regong art inheritors, artists and their painting
              academies and companies in Tongren County, Huangnan Tibetan
              Autonomous Prefecture, Qinghai Province. The original copyright of
              all digital images belongs to the original author and shall not be
              used for any commercial purpose without permission. This website,
              except for the original data of the database, belongs to Qinghai
              Normal University.
            </p>
            <h3>II. Database Terms of Use</h3>
            <p>
              1. All content of this website (except for design element
              materials generated by artificial intelligence algorithms),
              including but not limited to text, pictures, videos, sound, source
              code, logos, logos, layouts, expressions, other materials, etc.,
              are protected by copyright law, trademark law and corresponding
              international treaties, and shall not be copied, plagiarized or
              disseminated without authorization.
            </p>
            <p>
              2. The content on this website (except for the design element
              materials generated by artificial intelligence algorithms) is only
              for personal learning, research and appreciation, and shall not be
              used for commercial purposes. If there is any violation, the
              consequences shall be borne by the user. If there is a need for
              commercial use, you need to contact the database owner to
              communicate or purchase a commercial license.
            </p>
            <p>
              3. This website has the right to modify or delete the content of
              its website at any time without any reason or notice.
            </p>
            <p>
              4. This website does not guarantee the accuracy, reliability,
              validity, completeness and security of any content, services or
              materials, and does not assume any liability for any damage
              arising therefrom.
            </p>
            <h3>III. Disclaimer:</h3>
            <p>
              1. When using this website and database data, please abide by the
              relevant laws and regulations, policies and international
              practices of the Republic of China, and shall not use this website
              to engage in any violation of laws and regulations.
            </p>
            <p>
              2. This website is not responsible for the accuracy, authenticity,
              validity, timeliness, integrity and legality of the content
              published by users, nor does it bear any legal liability arising
              therefrom.
            </p>
            <p>
              3. This website cannot guarantee that the website service will not
              be interrupted, nor can it guarantee the timeliness, security and
              accuracy of the service. This website does not bear any
              responsibility for the losses that users may suffer in the process
              of using the website services.
            </p>
            <p>
              4. This website is not responsible for the products or services
              provided by third parties, nor is it responsible for any losses
              that users may suffer when purchasing or using products or
              services provided by third parties.
            </p>
            <p>
              5. This website is not responsible for infringements in the
              process of using the database, and database users who commit
              infringements are fully responsible for violations and
              infringements.
            </p>
            <h3>IV. Definitions and supplementary explanations:</h3>
            <p>
              1. This website: refers to the owner or owner of this website, and
              can also refer to any third party that provides services to this
              website by a legally authorized person.
            </p>
            <p>
              2. Users: refers to any user who browses this website, including
              visitors and registered users, as well as authorized users of the
              database.
            </p>
            <p>
              3. The right to interpret these Terms of Use belongs to Qinghai
              Normal University.
            </p>
          </div>
          <div class="explainBottom">
            <h2>Account application and permission description</h2>
            <div>
              [The database is copyrighted. Please do not use it for commercial
              activities. For database users, please fill in the
              <a
                href="/static/registrationForm.docx"
                download="下载"
                rel="external nofollow"
                >registration form</a
              >
              to apply.]
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="culture">
      <div class="section">
        <!-- PC -->
        <div
          class="left wow animate__fadeInLeft animate__animated hidden-xs-only"
        >
          <img src="../../assets/dataType/data_one.png" alt="" />
        </div>
        <!-- mobile -->
        <div
          class="left wow animate__fadeInLeft animate__animated hidden-sm-and-up"
        >
          <img src="../../assets/dataType/data_bottom.gif" alt="" />
        </div>
        <div class="right wow animate__fadeInRight animate__animated">
          <!-- PC -->
          <div class="right_art hidden-xs-only">
            <div class="art_top eng_art_top">Regong Art</div>
            <div class="art_middle">
              Human material cultural heritage | China's Intangible Cultural
              Heritage
            </div>
            <div class="art_bottom">
              Cultural treasures | Art Inheritance | Master works
            </div>
          </div>
          <!-- mobile -->
          <div class="right_art hidden-sm-and-up">
            <div class="art_top">Regong Art</div>
            <div class="art_middle">Human material cultural heritage</div>
            <div class="art_china">China's Intangible Cultural Heritage</div>
            <div class="art_bottom">
              Cultural treasures | Art Inheritance | Master works
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contact">
      <el-popover placement="left" width="240" trigger="hover">
        <div class="tel">Contact Number：{{templeContact}}</div>
        <div class="tel">Email：regong_art_db@163.com</div>
        <div class="mobile" slot="reference">
          <div class="message">
            <img src="../../assets/dataType/message.png" alt="" />
            <div>Consultation on the use of Regong IP</div>
          </div>
        </div>
      </el-popover>
    </div>
    <div></div>
  </div>
  <div class="database" v-else-if="this.language == 'en'">
    <Pic-top></Pic-top>
    <div class="databaseTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)"> ངོ་བྱང་།</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">གྲངས་མཛོད། </span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="databaseContent">
      <div class="section">
        <!-- PC端 -->
        <div class="dataType hidden-xs-only">
          <!-- <div
            class="left pointer wow animate__fadeInLeft animate__animated"
            @click="goDataDetail(1)"
          >
            <img src="../../assets/dataType/data_tang.png" alt="" />
            <div class="type">ཐང་ག</div>
          </div> -->
          <div class="middle wow animate__fadeIn animate__animated">
            <div class="pointer middleBottom" @click="goDataDetail(1)" style="margin-bottom:40px;">
              <img src="../../assets/dataType/data_tang_1.png" alt="" />
              <div class="type">ཐང་ག</div>
            </div>
            <div class="pointer middleTop" @click="goDataDetail(2)">
              <img src="../../assets/dataType/data_ni.jpg" alt="" />
              <div class="type">འཇིམ་བཟོ།</div>
            </div>
          </div>
          <div class="middle wow animate__fadeIn animate__animated">
            <div class="pointer middleBottom" @click="goDataDetail(3)" style="margin-bottom:40px;">
              <img src="../../assets/dataType/buhua.png" alt="" />
              <div class="type">ལྡེབས་རིས།</div>
            </div>
            <div class="pointer middleTop" @click="goDataDetail(5)">
              <img src="../../assets/dataType/data_cai.png" alt="" />
              <div class="type">ཚོན་རིས།</div>
            </div>
          </div>
          <div class="right wow animate__fadeIn animate__animated">
            <div class="pointer rightTop" @click="goDataDetail(4)" style="margin-bottom:40px;">
              <img src="../../assets/dataType/data_dui.png" alt="" />
              <div class="type">དྲས་དྲུབ།</div>
            </div>
            <div class="pointer rightBottom" @click="goDataDetail(6)">
              <img style="height:300px" src="../../assets/dataType/data_other.png" alt="" />
              <div class="type">གཞན་དག</div>
            </div>
          </div>
        </div>
        <!-- 手机端 -->
        <div class="mobile_dataType hidden-sm-and-up">
          <div class="typeTop">
            <!-- <div
              class="typeTopLeft wow animate__fadeInLeft animate__animated"
              @click="goDataDetail(1)"
            >
              <img src="../../assets/dataType/data_tang.png" alt="" />
              <div class="type">ཐང་ག</div>
            </div> -->
            <div
              class="typeTopRight"
            >
              <div class="dui wow animate__fadeInUp animate__animated" @click="goDataDetail(1)">
                <img src="../../assets/dataType/data_tang_1.png" alt="" />
                <div class="type">ཐང་ག</div>
              </div>
              <div class="bi wow animate__fadeInUp animate__animated" @click="goDataDetail(4)">
                <img src="../../assets/dataType/data_dui.png" alt="" />
                <div class="type">དྲས་དྲུབ།</div>
              </div>
            </div>
            <div
              class="typeTopRight"
            >
              <div class="dui wow animate__fadeInUp animate__animated" @click="goDataDetail(3)">
                <img src="../../assets/dataType/buhua.png" alt="" />
                <div class="type">ལྡེབས་རིས།</div>
              </div>
              <div class="bi wow animate__fadeInUp animate__animated" @click="goDataDetail(2)">
                <img src="../../assets/dataType/data_ni.jpg" alt="" />
              <div class="type">འཇིམ་བཟོ།</div>
              </div>
            </div>
          </div>
          <div class="typeBottom">
            <div
              class="ni wow animate__fadeInUp animate__animated"
              @click="goDataDetail(5)"
            >
                <img src="../../assets/dataType/data_cai.png" alt="" />
                <div class="type">ཚོན་རིས།</div>
            </div>
            <div
              class="cai wow animate__fadeInUp animate__animated"
              @click="goDataDetail(6)"
            >
              <img src="../../assets/dataType/data_other.png" alt="" />
              <div class="type">གཞན་དག</div>
            </div>
          </div>
        </div>
        <div class="explain wow animate__fadeInUp animate__animated">
          <div class="explainTop">
            <h2>
              རེབ་གོང་སྒྱུ་རྩལ་གྲངས་མཛོད་བེད་སྤྱོད་བྱེད་སྐབས་ཀྱི་བསྲུང་བྱའི་དོན་ཚན།
            </h2>
            <h3>
              རེབ་གོང་སྒྱུ་རྩལ་གྲངས་མཛོད་ཀྱི་ཐོག་མའི་གཞི་གྲངས་པར་དབང་གསལ་བསྒྲགས།
            </h3>
            <p>
              དྲ་ཚིགས་འདིའི་གྲངས་མཛོད་ཀྱི་ཐོག་མའི་གཞི་གྲངས་ཚང་མ་མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་བོད་རིགས་རང་སྐྱོང་ཁུལ་ཐུན་རིན་རྫོང་གི་རེབ་གོང་སྒྱུ་རྩལ་རྒྱུན་འཛིན་པ་དང་།
              སྒྱུ་རྩལ་པ།
              དེ་བཞིན་དེ་གར་ཡོད་པའི་ལྷ་རིས་གླིང་དང་ཀུང་སི་བཅས་ལས་སྡུད་ལེན་བྱས་པ་ཡིན།
              གྲངས་ཀའི་བརྙན་རིས་ཡོངས་ཀྱི་ཐོག་མའི་པར་དབང་ཐོག་མའི་རྩོམ་པ་པོར་དབང་ཞིང་།
              ཆོག་མཆན་མ་ཐོབ་པར་ཚོང་ལས་ཀྱི་སྤྱོད་སྒོ་གང་རུང་ལ་སྤྱད་མི་ཆོག །
              དྲ་ཚིགས་འདིའི་གྲངས་མཛོད་ཀྱི་ཐོག་མའི་གཞི་གྲངས་ཕུད་པའི་ནང་དོན་གཞན་དག་མཚོ་སྔོན་དགེ་འོས་སློབ་ཆེན་ལ་དབང་བ་ཡིན།
            </p>
            <h3>གྲངས་མཛོད་བེད་སྤྱོད་བྱེད་སྐབས་ཀྱི་བསྲུང་བྱའི་དོན་ཚན།</h3>
            <p>
              1.དྲ་ཚིགས་འདིའི་ནང་དོན་ཡོད་ཚད（མིས་བཟོས་རིག་ནུས་རྩི་ཐབས་གྲུབ་པའི་ཇུས་འགོད་གཞི་རྒྱུའི་རྒྱུ་ཆ་ཕུད།）དེ།
              འདིའི་ནང་ཡི་གེ་དང་། པར་རིས། བརྙན་རིས། སྒྲ། ཁུངས་ཀྱི་ཚབ་ཨང་། རྟགས།
              མཚོན་རྟགས། པར་གཞི། མཚོན་ཚུལ་མཚོན་སྟངས།
              རྒྱུ་ཆ་གཞན་པ་སོགས་དང་དེར་མ་ཟད་པ་མཐའ་དག་ལ།
              བརྩམས་ཆོས་བདག་དབང་བཅའ་ཁྲིམས་དང་། ཚོང་རྟགས་ཀྱི་བཅའ་ཁྲིམས།
              དེ་དང་མཚུངས་པའི་རྒྱལ་སྤྱིའི་ཆིངས་ཡིག་བཅས་ཀྱི་སྲུང་སྐྱོབ་ཐོབ་ཡོད་པས།
              ཆོག་མཆན་མ་ཐོབ་པར་གང་འདོད་དུ་འདྲ་བཟོ་དང་། བཤུ་འབྲི།
              རྒྱུད་སྒྲོག་བཅས་བྱེད་མི་རུང་།
            </p>
            <p>
              2.དྲ་ཚིགས་འདིའི་སྟེང་གི་ནང་དོན（མི་ཐབས་ལ་བརྟེན་པའི་རིག་ནུས་རྩི་ཐབས་ལས་གྲུབ་པའི་ཇུས་འགོད་གཞི་རྒྱུའི་རྒྱུ་ཆ་ཕུད）ནི་མི་སྒེར་གྱི་སློབ་སྦྱོང་དང་།
              ཞིབ་འཇུག །མྱོང་རོལ་བཅས་ལ་མཁོ་འདོན་བྱས་པ་ཙམ་ཡིན་པས།
              ཚོང་ལས་ཀྱི་སྤྱོད་སྒོར་སྤྱོད་མི་རུང་།
              །གལ་ཏེ་དེ་དང་འགལ་ཚེ་དེ་མཚུངས་ཀྱི་བཅའ་ཁྲིམས་འགན་འཁྲི་འཁུར་དགོས།
              གལ་ཏེ་ཚོང་ལས་ཀྱི་དགོས་མཁོ་ཡོད་ན།
              གྲངས་མཛོད་ཀྱི་བདག་པོ་དང་ཐོག་མའི་རྩོམ་པ་པོར་འབྲེལ་གཏུགས་བྱེད་པའམ་ཚོང་ལས་ཀྱི་སྤྱོད་སྒོར་བེད་སྤྱོད་བྱས་ཆོག་པའི་ཆོག་མཆན་ཉོ་དགོས།
            </p>
            <p>
              3.དྲ་ཚིགས་འདི་ལ་ག་དུས་ཡིན་ཡང་ང་དྲ་ཚིགས་ཀྱི་ནང་དོན་ལ་བཟོ་བཅོས་སམ་བསུབ་སྣོག་བྱ་རྒྱུའི་དབང་ཆ་ཡོད་པས།
              དེ་ལ་རྒྱུ་མཚན་དང་བརྡ་ཐོ་གང་ཡང་མི་དགོས།
            </p>
            <p>
              4.དྲ་ཚིགས་འདིས་འདི་གའི་ནང་དོན་དང་།
              ཞབས་ཞུའམ་རྒྱུ་ཆ་བཅས་ཀྱི་གནད་འཁེལ་རང་བཞིན་དང་། བློས་འགེལ་རང་བཞིན།
              ཕན་ནུས་རང་བཞིན། ཆ་ཚང་རང་བཞིན།
              བདེ་འཇགས་རང་བཞིན་བཅས་ལ་འགན་ལེན་མི་བྱེད་པ་དང་།
              དེ་འབྲེལ་གནོད་སྐྱོན་གྱི་འགན་འཁྲི་གང་ཡང་མི་འཁུར།
            </p>
            <h3>འགན་མེད་བཟོ་བའི་གསལ་བསྒྲགས།</h3>
            <p>
              1.སྤྱོད་མཁན་གྱིས་དྲ་ཚིགས་འདི་དང་གྲངས་མཛོད་ཀྱི་གཞི་གྲངས་བེད་སྤྱོད་བྱེད་སྐབས་ཀྲུང་ཧྭ་མི་དམངས་སྤྱི་མཐུན་རྒྱལ་ཁབ་ཀྱི་འབྲེལ་ཡོད་བཅའ་ཁྲིམས་དང་།
              ཁྲིམས་སྲོལ། སྲིད་ཇུས།
              དེ་བཞིན་རྒྱལ་སྤྱིའི་རྒྱུན་སྲོལ་བཅས་ལ་བརྩི་སྲུང་ཞུ་དགོས་པ་ལས།
              དྲ་ཚིགས་འདི་བེད་སྤྱད་ནས་བཅའ་ཁྲིམས་དང་ཁྲིམས་སྲོལ་དང་འགལ་བའི་བྱ་སྤྱོད་གང་ཡང་སྤེལ་མི་རུང་།
            </p>
            <p>
              2.དྲ་ཚིགས་འདིས་སྤྱོད་མཁན་གྱིས་ཁྱབ་བསྒྲགས་བྱས་པའི་ནང་དོན་གྱི་གནད་འཁེལ་རང་བཞིན་དང་།
              བདེན་དངོས་རང་བཞིན། ཕན་ནུས་རང་བཞིན། དུས་ཐོག་རང་བཞིན། ཆ་ཚང་རང་བཞིན།
              ཁྲིམས་མཐུན་རང་བཞིན་བཅས་ལ་འགན་མི་འཁུར་ལ་དེ་འབྲེལ་ལས་བྱུང་བའི་ཁྲིམས་ལུགས་ཀྱི་འགན་འཁྲི་གང་ཡང་མི་འཁུར།
            </p>
            <p>
              3.དྲ་ཚིགས་འདིས་དྲ་ཚིགས་ཞབས་ཞུ་མཚམས་མི་འཆད་པ་དང་།
              ཞབས་ཞུའི་དུས་ཐོག་རང་བཞིན་དང་། བདེ་འཇགས་རང་བཞིན།
              གནད་འཁེལ་རང་བཞིན་བཅས་ལ་ཁག་ཐེག་བྱེད་མི་ཐུབ་པས།
              དྲ་ཚིགས་བེད་སྤྱོད་བྱེད་པའི་བརྒྱུད་རིམ་ཁྲོད་དུ་སྤྱོད་མཁན་ལ་འབྱུང་རུང་གི་གྱོང་གུན་ལ་དྲ་ཚིགས་འདིས་འགན་ཅི་ཡང་མི་འཁུར།
            </p>
            <p>
              4.དྲ་ཚིགས་འདིས་ཕྱོགས་གསུམ་པས་འདོན་སྤྲོད་བྱས་པའི་ཐོན་རྫས་སམ་ཞབས་ཞུ་ལ་འགན་མི་འཁུར་ལ།
              སྤྱོད་མཁན་གྱིས་ཕྱོགས་གསུམ་པས་འདོན་སྤྲོད་བྱས་པའི་ཐོན་རྫས་སམ་ཞབས་ཞུ་ཉོ་བའམ་བེད་སྤྱོད་བྱེད་སྐབས་ཐེབས་སྲིད་པའི་གྱོང་གུན་ལའང་འགན་མི་འཁུར།
            </p>
            <p>
              5.དྲ་ཚིགས་འདིས་གཞི་གྲངས་མཛོད་བེད་སྤྱོད་བྱེད་པའི་བརྒྱུད་རིམ་ཁྲོད་ཀྱི་དབང་གནོད་བྱ་སྤྱོད་ལ་འགན་མི་འཁུར་བ་དང་།
              དབང་གནོད་བྱ་སྤྱོད་སྤེལ་བའི་གྲངས་མཛོད་སྤྱོད་མཁན་གྱིས་སྒྲིག་འགལ་དང་དབང་གནོད་བྱ་སྤྱོད་ལ་འགན་ཡོངས་སུ་རྫོགས་པ་འཁུར་དགོས།
            </p>
            <h3>མཚན་ཉིད་དང་ཁ་གསབ་གསལ་བཤད།</h3>
            <p>
              1.དྲ་ཚིགས་འདི་ཞེས་པ་ནི་དྲ་ཚིགས་འདི་ལ་དབང་མཁན་ནམ་དྲ་ཚིགས་འདིའི་བདག་པོའམ་ཡང་ན་ཁྲིམས་མཐུན་ངང་དབང་ཆ་སྤྲད་ནས་དྲ་ཚིགས་འདི་ལ་ཞབས་འདེགས་ཞུ་མཁན་གྱི་ཕྱོགས་གསུམ་པ་གང་རུང་ཞིག་ལ་གོ་དགོས།
            </p>
            <p>
              2.སྤྱོད་མཁན་ཞེས་པ་ནི་དྲ་ཚིགས་འདི་ལ་ལྟ་མཁན་གྱི་སྤྱོད་མཁན་ལ་ཟེར་ཞིང་།
              དེའི་ནང་དུ་འཚམས་འདྲིར་ཡོང་མཁན་དང་ཐོ་འགོད་བྱེད་མཁན་དང་དེ་བཞིན་གཞི་གྲངས་མཛོད་བེད་སྤྱོད་བྱེད་དབང་བསྐུར་བའི་སྤྱོད་མཁན་བཅས་འདུ།
            </p>
            <p>
              3.བེད་སྤྱོད་ཀྱི་བསྲུང་བྱའི་དོན་ཚན་གྱི་འགྲེལ་བཤད་བྱེད་དབང་མཚོ་སྔོན་དགེ་འོས་སློབ་ཆེན་ལ་དབང་བ་ཡིན།
            </p>
          </div>
          <div class="explainBottom">
            <h2>རྩིས་ཐོའི་ཨང་གྲངས་རེ་ཞུ་དང་དབང་ཚད་གསལ་བཤད་།</h2>
            <div>
              [གཞི་གྲངས་མཛོད་པར་དབང་ལ་དབང་བ་དང་།དེ་ནི་ཚོང་ལས་བྱ་སྤྱོད་དང་།གཞི་གྲངས་མཛོད་སྤྱོད་མཁན་<a
                href="/static/registrationForm.docx"
                download="下载"
                rel="external nofollow"
                >ཐོ་འགོད་རེའུ་མིག་</a
              >སྐོང་རོགས་རེ་ཞུ་།]
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="culture">
      <div class="section">
        <!-- PC -->
        <div
          class="za_left wow animate__fadeInLeft animate__animated hidden-xs-only"
        >
          <img src="../../assets/dataType/data_one.png" alt="" />
        </div>
        <!-- mobile -->
        <div
          class="za_left left wow animate__fadeInLeft animate__animated hidden-sm-and-up"
        >
          <img src="../../assets/dataType/data_bottom.gif" alt="" />
        </div>
        <div class="right wow animate__fadeInRight animate__animated">
          <!-- PC -->
          <div class="za_right_art hidden-xs-only">
            <div class="art_top">རེབ་གོང་སྒྱུ་རྩལ།</div>
            <div class="art_middle">
              མིའི་རིགས་ཀྱི་གཟུགས་བཅས་རིག་གནས་ཤུལ་བཞག ། |
              ཀྲུང་གོའི་གཟུགས་མེད་ཤུལ་བཞག་རིག་གནས།
            </div>
            <div class="art_bottom">
              རིག་གནས་གཅེས་ནོར། | སྒྱུ་རྩལ་རྒྱུན་འཛིན། |
              བཟོ་བོ་མཁས་པའི་བརྩམས་ཆོས།
            </div>
          </div>
          <!-- mobile -->
          <div class="right_art hidden-sm-and-up">
            <div class="art_top">རེབ་གོང་སྒྱུ་རྩལ།</div>
            <div class="art_middle">
              མིའི་རིགས་ཀྱི་གཟུགས་བཅས་རིག་གནས་ཤུལ་བཞག །
            </div>
            <div class="art_china">ཀྲུང་གོའི་གཟུགས་མེད་ཤུལ་བཞག་རིག་གནས།</div>
            <div class="art_bottom">
              རིག་གནས་གཅེས་ནོར། | སྒྱུ་རྩལ་རྒྱུན་འཛིན། |
              བཟོ་བོ་མཁས་པའི་བརྩམས་ཆོས།
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contact">
      <el-popover placement="left" width="240" trigger="hover">
        <div class="tel">འབྲེལ་གཏུགས་ཨང་གྲངས།：{{templeContact}}</div>
        <div class="tel">སྦྲགས་ཡིག：regong_art_db@163.com</div>
        <div class="mobile" slot="reference">
          <div class="message">
            <img src="../../assets/dataType/message.png" alt="" />
            <div>IPབཀོལ་སྤྱོད་འདྲི་རྩད།</div>
          </div>
        </div>
      </el-popover>
    </div>
    <div></div>
  </div>
  <div class="database" v-else>
    <Pic-top></Pic-top>
    <div class="databaseTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">数据库</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="databaseContent">
      <div class="section">
        <!-- PC端 -->
        <div class="dataType hidden-xs-only">
          <!-- <div
            class="left pointer wow animate__fadeInLeft animate__animated"
            @click="goDataDetail(1)"
          >
            <img src="../../assets/dataType/data_tang.png" alt="" />
            <div class="type">唐卡</div>
          </div> -->
          <div class="middle wow animate__fadeIn animate__animated">
            <div class="pointer middleBottom" @click="goDataDetail(1)" style="margin-bottom:40px;">
              <img src="../../assets/dataType/data_tang_1.png" alt="" />
              <div class="type">唐卡</div>
            </div>
            <div class="pointer middleTop" @click="goDataDetail(2)">
              <img src="../../assets/dataType/data_ni.jpg" alt="" />
              <div class="type">泥塑</div>
            </div>
          </div>
          <div class="middle wow animate__fadeIn animate__animated">
            <div class="pointer middleBottom" @click="goDataDetail(3)" style="margin-bottom:40px;">
              <img src="../../assets/dataType/buhua.png" alt="" />
              <div class="type">壁画</div>
            </div>
            <div class="pointer rightBottom" @click="goDataDetail(5)">
              <img src="../../assets/dataType/data_cai.png" alt="" />
              <div class="type">彩绘</div>
            </div>
          </div>
          <div class="right wow animate__fadeIn animate__animated">
            <div class="pointer rightTop" @click="goDataDetail(4)" style="margin-bottom:40px;">
              <img src="../../assets/dataType/data_dui.png" alt="" />
              <div class="type">堆绣</div>
            </div>
            <div class="pointer middleTop" @click="goDataDetail(6)">
              <img style="height:300px" src="../../assets/dataType/data_other.png" alt="" />
              <div class="type">其他</div>
            </div>
          </div>
        </div>
        <!-- 手机端 -->
        <div class="mobile_dataType hidden-sm-and-up">
          <div class="typeTop">
            <!-- <div
              class="typeTopLeft wow animate__fadeInLeft animate__animated"
              @click="goDataDetail(1)"
            >
              <img src="../../assets/dataType/data_tang.png" alt="" />
              <div class="type">唐卡</div>
            </div> -->
            <div
              class="typeTopRight"
            >
              <div class="dui wow animate__fadeInUp animate__animated" @click="goDataDetail(1)">
                <img src="../../assets/dataType/data_tang_1.png" alt="" />
                <div class="type">唐卡</div>
              </div>
              <div class="bi wow animate__fadeInUp animate__animated" @click="goDataDetail(4)">
                <img src="../../assets/dataType/data_dui.png" alt="" />
                <div class="type">堆绣</div>
              </div>
            </div>
            <div
              class="typeTopRight"
            >
              <div class="dui wow animate__fadeInUp animate__animated" @click="goDataDetail(3)">
                <img src="../../assets/dataType/buhua.png" alt="" />
                <div class="type">壁画</div>
              </div>
              <div class="bi wow animate__fadeInUp animate__animated" @click="goDataDetail(2)">
                
                <img src="../../assets/dataType/data_ni.jpg" alt="" />
              <div class="type">泥塑</div>
              </div>
            </div>
          </div>
          <div class="typeBottom">
            <div
              class="ni wow animate__fadeInUp animate__animated"
              @click="goDataDetail(5)"
            >
              <img src="../../assets/dataType/data_cai.png" alt="" />
              <div class="type">彩绘</div>
            </div>
            <div
              class="cai wow animate__fadeInUp animate__animated"
              @click="goDataDetail(6)"
            >
              <img src="../../assets/dataType/data_other.png" alt="" />
              <div class="type">其它</div>
            </div>
          </div>
        </div>
        <div class="explain wow animate__fadeInUp animate__animated">
          <div class="explainTop">
            <h2>热贡艺术数据库使用条款</h2>
            <h3>一、热贡艺术数据库原始数据版权声明：</h3>
            <p>
              本网站数据库原始数据均采集于青海省黄南藏族自治州同仁县各热贡艺术传承人、艺术家及其所在画院、公司。全部数字图像原始版权归原创作者所有，未经许可不得用于任何商业用途。本网站除数据库原始数据外的其他内容，归青海师范大学所有。
            </p>
            <h3>二、数据库使用条款</h3>
            <p>
              1、本网站的所有内容（除人工智能算法生成的设计元素素材外），包括但不限于文字、图片、视频、声音、源代码、标识、标志、版式、表现形式、其他资料等，均受著作权法、商标法及相应的国际条约保护，未经授权不得进行复制、抄袭或传播。
            </p>
            <p>
              2、本网站上的内容（除人工智能算法生成的设计元素素材外）仅供个人学习、研究和欣赏，不得用于商业用途，如有违反，后果由用户自行承担。如有商业用途需求，需联系数据库所有者沟通或购买商业授权许可。
            </p>
            <p>
              3、本网站有权在任何时候对其网站内容进行修改或删除，而不需要任何理由或通知。
            </p>
            <p>
              4、本网站不保证任何内容、服务或资料的准确性、可靠性、有效性、完整性和安全性，不承担任何由此造成的损害责任。
            </p>
            <h3>三、免责声明：</h3>
            <p>
              1、用户在使用本网站及数据库数据时，请遵守中华共和国相关法律法规、政策以及国际惯例，不得利用本网站从事任何违反法律法规的行为。
            </p>
            <p>
              2、本网站不就用户发布的内容的准确性、真实性、有效性、及时性、完整性、合法性负责，也不承担因此引起的任何法律责任。
            </p>
            <p>
              3、本网站不能保证网站服务不会中断，也不能保证服务的及时性、安全性、准确性，对用户在使用网站服务过程中可能遭致的损失，本网站不承担任何责任。
            </p>
            <p>
              4、本网站不就由第三方提供的产品或服务负责，也不对用户在购买或使用第三方提供的产品或服务时可能遭受的任何损失负责。
            </p>
            <p>
              5、本网站不对数据库使用过程中的侵权行为负责，实施侵权行为的数据库使用者对违规和侵权行为负有全部责任。
            </p>
            <h3>四、定义及补充说明：</h3>
            <p>
              1、本网站：指本网站的所有者或拥有者，也可以指由合法授权人为本网站提供服务的任何第三方。
            </p>
            <p>
              2、用户：指任何浏览本网站的用户，包括访客和注册用户以及数据库授权使用用户。
            </p>
            <p>3、本使用条款解释权归青海师范大学所有。</p>
          </div>
          <div class="explainBottom">
            <h2>账号申请及权限说明</h2>
            <div>
              [数据库版权所有，请勿用于商业行为，数据库使用者请填写<a
                href="/static/registrationForm.docx"
                download="下载"
                rel="external nofollow"
                >登记表</a
              >进行申请]
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="culture">
      <div class="section">
        <!-- PC -->
        <div
          class="left wow animate__fadeInLeft animate__animated hidden-xs-only"
        >
          <img src="../../assets/dataType/data_one.png" alt="" />
        </div>
        <!-- mobile -->
        <div
          class="left wow animate__fadeInLeft animate__animated hidden-sm-and-up"
        >
          <img src="../../assets/dataType/data_bottom.gif" alt="" />
        </div>
        <div class="right wow animate__fadeInRight animate__animated">
          <!-- PC -->
          <div class="right_art hidden-xs-only">
            <div class="art_top">热贡艺术</div>
            <div class="art_middle">人类物质文化遗产 | 中国非物质文化遗产</div>
            <div class="art_bottom">文化瑰宝 | 艺术传承 | 大师作品</div>
          </div>
          <!-- mobile -->
          <div class="right_art hidden-sm-and-up">
            <div class="art_top">热贡艺术</div>
            <div class="art_middle">人类物质文化遗产</div>
            <div class="art_china">中国非物质文化遗产</div>
            <div class="art_bottom">文化瑰宝 | 艺术传承 | 大师作品</div>
          </div>
        </div>
      </div>
    </div>
    <div class="contact">
      <el-popover placement="left" width="240" trigger="hover">
        <div class="tel">联系电话：{{templeContact}}</div>
        <div class="tel">邮件：regong_art_db@163.com</div>
        <div class="mobile" slot="reference">
          <div class="message">
            <img src="../../assets/dataType/message.png" alt="" />
            <div>热贡IP使用咨询</div>
          </div>
        </div>
      </el-popover>
    </div>
    <div></div>
  </div>
</template>
<script>
import PicTop from "../../components/picsTop.vue";
export default {
  components: {
    PicTop,
  },
  data() {
    return {
      language: this.$store.state.language,
      templeContact:'18997193666'
    };
  },
  mounted() {
    new this.$wow.WOW().init();
  },
  created() {},
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  methods: {
    goDataDetail(index) {
      let token = localStorage.getItem("token");
      if (token) {
        this.$router.push({
          path: "/dataBaseWork",
          query: { category: index },
        });
      } else {
        this.$message.error("未登录");
      }
    },
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
  },
};
</script>
<style lang="scss">
.database {
  .pointer {
     cursor: pointer;
  }
  background: url("../../assets/newImage/index/could_right.png") no-repeat right
    bottom;
  background-position: 100% 100%;
  background-size: 7%;
  .databaseTop {
    position: relative;
    border-bottom: 1px solid #f4f5f6;
    .section {
      padding: 50px 0;
      font-size: 18px;
      position: relative;
      .section_left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 88;
        .color {
          color: #ed201a;
        }
        span {
          cursor: pointer;
        }
      }
    }
    .cloudLeft {
      position: absolute;
      top: 50%;
      left: 0;
      z-index: 1;
      width: 125px;
      height: 95px;
    }
  }
  .databaseContent {
    .section {
      .dataType {
        display: flex;
        justify-content: space-between;
        padding: 60px 0 50px 0;
        img {
          width: 365px;
          display: block;
          transition: all 500ms ease;
        }
        .left,
        .rightTop,
        .rightBottom,
        .middleTop,
        .middleBottom {
          position: relative;
          overflow: hidden;
          border-radius: 4px;
          .type {
            position: absolute;
            bottom: 0;
            right: 0;
            width: 100%;
            border-radius: 4px;
            text-align: center;
            line-height: 50px;
            font-size: 28px;
            font-family: "fangzang";
            color: #fff;
            height: 50px;
            background-color: rgba(1, 0, 0, 0.5);
          }
          .eng_type {
            font-family: "Times New Roman", Times, serif;
          }
        }
        .left,
        .rightTop,
        .rightBottom,
        .middleTop,
        .middleBottom :hover {
          img {
            transform: scale(1.05);
          }
        }
        .middle {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .middleTop,
          .middleBottom {
            img {
              height: 300px;
            }
          }
        }
        .right {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
      }
      .explain {
        padding: 45px;
        background-color: #f5f5f5;
        .title {
          font-size: 28px;
          padding: 8px;
        }
        h3 {
          margin-top: 6px;
        }
        p {
          letter-spacing: 1px;
          font-size: 16px;
          line-height: 1.5;
          text-align: justify;
          margin-top: 4px;
        }
        .explainTop {
          margin-bottom: 45px;
        }
        .explainBottom {
          div {
            font-size: 16px;
            margin-top: 10px;
            a {
              color: #39f;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  .culture {
    position: relative;
    margin: 50px 0;
    .section {
      display: flex;
      background-color: #f5f5f5;
      flex-wrap: wrap;
      .left {
        flex: 1;
        img {
          width: 792px;
          display: block;
        }
      }
      .za_left {
        flex: 1;
        img {
          width: 780px;

          display: block;
        }
      }
      .right {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        .right_art {
          display: flex;
          justify-content: center;
          flex-direction: column;
          text-align: right;
          .art_top {
            font-family: "fangzang";
            font-size: 28px;
          }
          .eng_art_top {
            font-family: "Times New Roman", Times, serif;
          }
          .art_middle {
            margin: 30px 0 20px 0;
          }
          .art_middle,
          .art_bottom {
            font-size: 15px;
          }
        }
        .za_right_art {
          display: flex;
          justify-content: center;
          flex-direction: column;
          .art_top {
            font-family: "fangzang";
            font-size: 28px;
            margin-left: 190px;
          }
          .art_middle {
            margin: 30px 0 20px 0;
            font-size: 15px;
          }
          .art_bottom {
            font-size: 15px;
            margin-left: 70px;
          }
        }
      }
    }
  }
  .contact {
    z-index: 999;
    color: #fff;
    position: fixed;
    right: 2%;
    bottom: 30%;
    .message {
      padding: 0 10px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 104px;
      height: 104px;
      border-radius: 100%;
      background-color: #99131a;
      margin-bottom: 20px;
      box-shadow: 0 0 10px #99131a;
      font-size: 12px;
      img {
        width: 32px;
        margin-bottom: 6px;
      }
    }
    .eng_message {
      width: 110px;
      height: 110px;
    }
    .za_message {
      width: 110px;
      height: 110px;
    }
  }
}
@media (max-width: 768px) {
  .database {
    background-size: 15%;
    padding-bottom: 1rem;
    .databaseTop {
      .section {
        background: url("../../assets/newImage/index/could_left.png") no-repeat
          top left;
        background-position: 0 50%;
        background-size: 15%;
        padding: 0.6rem 0.2rem;
        font-size: 0.3rem;
        .section_left {
          left: 0.2rem;
        }
      }
      .moblieCloudLeft {
        position: absolute;
        top: 6%;
        right: 0;
        width: 1.25rem;
      }
    }
    .databaseContent {
      .section {
        .mobile_dataType {
          .typeTop {
            display: flex;
            justify-content: space-between;
            .typeTopLeft {
              position: relative;
              img {
                width: 3.3rem;
                height: 100%;
                vertical-align: bottom;
              }
              .type {
                position: absolute;
                bottom: 0;
                right: 0;
                width: 100%;
                border-radius: 0.1rem;
                text-align: center;
                line-height: 0.6rem;
                font-size: 0.3rem;
                color: #fff;
                height: 0.6rem;
                background-color: rgba(1, 0, 0, 0.5);
              }
            }
            .typeTopRight {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              .dui,
              .bi {
                height: 2.7rem;
                position: relative;
                img {
                  height: 100%;
                  width: 3.3rem;
                  vertical-align: bottom;
                }
                .type {
                  position: absolute;
                  bottom: 0;
                  right: 0;
                  width: 100%;
                  border-radius: 0.1rem;
                  text-align: center;
                  line-height: 0.6rem;
                  font-size: 0.3rem;
                  color: #fff;
                  height: 0.6rem;
                  background-color: rgba(1, 0, 0, 0.5);
                }
              }
              .bi {
                margin-top: 0.4rem;
              }
            }
          }
          .typeBottom {
            margin-top: 0.4rem;
            display: flex;
            justify-content: space-between;
            .ni,
            .cai {
              height: 2.6rem;
              position: relative;
              img {
                width: 3.3rem;
                vertical-align: bottom;
                height: 100%;
              }
              .type {
                position: absolute;
                bottom: 0;
                right: 0;
                width: 100%;
                border-radius: 0.1rem;
                text-align: center;
                line-height: 0.6rem;
                font-size: 0.3rem;
                color: #fff;
                height: 0.6rem;
                background-color: rgba(1, 0, 0, 0.5);
              }
            }
          }
        }
        .explain {
          padding: 0.3rem 0.2rem;
          margin-top: 0.3rem;
          .explainTop {
            margin-bottom: 0;
            .title {
              font-size: 0.4rem;
              padding: 0 0 0.1rem 0;
            }
          }
          .explainBottom {
            .title {
              font-size: 0.4rem;
              padding: 0.2rem 0 0.1rem 0;
            }
          }
        }
      }
    }
    .culture {
      margin: 0.5rem 0 0 0;
      .section {
        .left {
          img {
            width: 3.5rem;
            height: 1.8rem;
          }
        }
        .right {
          padding: 0 0.05rem;
          .right_art {
            text-align: left;
            .art_top {
              font-size: 0.3rem;
            }
            .art_middle,
            .art_china,
            .art_bottom {
              font-size: 0.2rem;
            }
            .art_middle {
              margin: 0;
            }
          }
        }
      }
    }
    .contact {
      position: fixed;
      z-index: 1000;
      right: 1%;
      bottom: 35%;
      .message {
        padding: 0.2rem;
        width: 1.7rem;
        height: 1.7rem;
        img {
          width: 0.4rem;
        }
        div {
          font-size: 0.2rem !important;
        }
      }
    }
    .cloudright {
      position: absolute;
      right: 0;
      bottom: -3.5%;
      width: 1.25rem;
    }
  }
}
</style>
